/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { ReportBodyDtoStatus } from './reportBodyDtoStatus';
import type { ReportBodyDtoAnimalType } from './reportBodyDtoAnimalType';
import type { ReportBodyDtoWildType } from './reportBodyDtoWildType';
import type { ReportBodyDtoSurveillanceType } from './reportBodyDtoSurveillanceType';
import type { ReportBodyDtoHumanAffected } from './reportBodyDtoHumanAffected';
import type { ReportBodyDtoDomesticAnimalAffected } from './reportBodyDtoDomesticAnimalAffected';
import type { DiagnosticProcedureBodyDto } from './diagnosticProcedureBodyDto';
import type { AssetBodyDto } from './assetBodyDto';

export interface ReportBodyDto {
  /** User specified language. Must follow IETF subtag format. */
  specifiedLanguage?: string;
  /** Code of the report */
  code?: string;
  /** Publication status of the report */
  status: ReportBodyDtoStatus;
  /** Type of animal */
  animalType?: ReportBodyDtoAnimalType;
  /** Species */
  specie?: string;
  /** Wild type */
  wildType?: ReportBodyDtoWildType;
  /** Latitude */
  latitude?: number;
  /** Longitude */
  longitude?: number;
  /** Inaccurate location flag */
  inaccurateLocation?: boolean;
  /** Detection date */
  detectionDate?: string;
  /** Surveillance type */
  surveillanceType?: ReportBodyDtoSurveillanceType;
  /** Description */
  description?: string;
  /** Number of deaths */
  numberOfDeaths?: number;
  /** Number of sicks */
  numberOfSicks?: number;
  /** Population size */
  populationSize?: number;
  /** Human affected */
  humanAffected?: ReportBodyDtoHumanAffected;
  /** Domestic animal affected */
  domesticAnimalAffected?: ReportBodyDtoDomesticAnimalAffected;
  /** Known cause */
  knownCause?: boolean;
  /** Order */
  order?: string;
  /** Etiology type code */
  etiologyTypeCode?: string;
  /** Etiological agent code */
  etiologicalAgentCode?: string;
  /** Note for the version */
  versionNote?: string;
  /** Diagnostic procedures */
  diagnosticProcedures?: DiagnosticProcedureBodyDto[];
  /** Assets associés au rapport */
  assets?: AssetBodyDto[];
  offlineMode?: boolean;
}
